import { render, staticRenderFns } from "./A.vue?vue&type=template&id=64cd6fca&scoped=true"
import script from "./A.vue?vue&type=script&lang=js"
export * from "./A.vue?vue&type=script&lang=js"
import style0 from "./A.vue?vue&type=style&index=0&id=64cd6fca&prod&scoped=true&lang=css"
import style1 from "./A.vue?vue&type=style&index=1&id=64cd6fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd6fca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSimpleTable,VTextField})
